import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import OutreachForm from '../components/OutreachForm';
import {
  requestOutreachDetails,
  requestOutreachTypes, updateOutreach
} from '../../../store/outreach/OutreachActions';
import moment from 'moment';
import { hostTitle } from '../../../config/ui';

class OutreachEdit extends React.Component {
  componentWillMount() {
    this.props.getOutreach(this.props.params.id, {
      tenantId: this.props.tenantId,
    });
  }

  searchOutreachTypes = () => {
    return this.props
      .getOutreachTypes({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  onSubmit = (values) => {
    this.props
      .updateOutreach(values, {
        tenantId: this.props.tenantId,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Outreach has been saved.');
          hashHistory.push('/outreach-manager/');
        }
      });
  };

  onCancel = () => {
    hashHistory.push('/outreach-manager/');
  };

  getDetails = () => {
    const {
      data: { outreach },
      params: { id },
    } = this.props;
    if (id === '00000000-0000-0000-0000-000000000000' && outreach) {
      outreach['date'] = moment().format(
        'YYYY-MM-DDThh:mm:ss',
      );
    }
    return outreach ? outreach : {};
  };

  render() {
    const {
      data: { outreach },
    } = this.props;

    return (
      <div id="content">
        {outreach.id && <Helmet title={`${outreach.id} – ${hostTitle()}`} />}
        <BigBreadcrumbs
          items={[
            'Administration',
            { title: 'Outreach Manager', route: '/outreach-manager' },
            'Outreach',
          ]}
          icon="fa fa-fw fa-database"
          className=""
        />

        <WidgetGrid>
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            closeButton={true}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>
              <h2>Edit outreach {outreach.id && <i>({outreach.id})</i>}</h2>
            </header>
            <div>
              <div className="widget-body">
                <OutreachForm
                  searchOutreachTypes={this.searchOutreachTypes}
                  initialValues={this.getDetails()}
                  masterPatientId={1}
                  onSubmit={this.onSubmit}
                  onCancel={this.onCancel}
                />
              </div>
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.outreach,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getOutreachTypes: (params) => dispatch(requestOutreachTypes(params)),
    getOutreach: (id, params) => dispatch(requestOutreachDetails(id, params)),
    updateOutreach: (task, params) => dispatch(updateOutreach(task, params)),
  }),
)(OutreachEdit);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/OutreachEdit.js